import { FC, HTMLAttributes } from 'react';

import classNames from 'classnames';

import './Tabs.scss';

import { PageOrientation, TestMetadata } from '../types';

export interface TabsProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  innerClassName?: string;
  // Test IDs for component sections
  testMetadata?: TestMetadata;
  orientation?: PageOrientation;
}

const Tabs: FC<TabsProps> = ({
  className,
  innerClassName,
  children,
  testMetadata,
  orientation = 'horizontal',
  ...other
}) => {
  const listClass = classNames(innerClassName, 'sb-tabs__list', {
    'sb-tabs__list-horizontal': orientation === 'horizontal',
    'sb-tabs__list-vertical': orientation === 'vertical',
  });

  const tabsClass = classNames(className, 'sb-tabs', {
    'sb-tabs__horizontal': orientation === 'horizontal',
    'sb-tabs__vertical': orientation === 'vertical',
  });

  return (
    <div className={tabsClass} {...other} {...testMetadata}>
      <div className={listClass}>{children}</div>
    </div>
  );
};

export default Tabs;
